// /////////////////////
// asc_cta_interaction
// event_action_result
// play|restart|vr_play|spin|popup|slideout|exit|error|search|calc|
// start|stop|redirect|open|close|increase|decrease|clear|check|uncheck|complete|dropdown|none|shown

// event_action
// click|swipe_left|swipe_right|swipe_up|swipe_down|hover|view|scroll|field_input|keystroke

// element_subtype
// cta_button|cta_icon|nav_button|nav_icon|nav_tab|hamburger_menu|mega_menu|sidebar_menu|inline_menu|hyperlink|
// content|share_icon|image|input_field|toggle|dropdown|kebab_menu|hero_image

// element_type
// header|banner|popup|form|digital_retailing_tool|trade_tool|chat_tool|accessibility_tool|
// search_tool|scheduling_tool|gallery|map|footer|video|item_details|pagination|body|menu
// /////////////////////

const ascCtaInteraction = {
	shared: [
		'[[mapping.configuration.sharedPayloads.sharedProps]]',
		'[[mapping.configuration.sharedPayloads.vehicleData]]'
	],
	element_text: '[[eventData.text]]',
	element_type: 'item_details',
	element_subtype: 'cta_button',
	event: 'asc_cta_interaction',
	event_action: 'click',
	event_action_result: 'redirect',
	link_url: '[[eventData.url]]'
};

export default {
	events: {
		'ddc.link.generic': [
			// set up based off https://coxautoinc-my.sharepoint.com/:p:/p/erin_george/ER00hnRpDYNDrUoUDMkXyYwBvnsRFgKwtbZ2xAeYUr18Mg?e=3ZlFir
			// and https://docs.google.com/spreadsheets/d/1AXdwZ9eAxhhGvhtij5MQlC-3CSXxR8vQ0ri9X3ACD4U/edit#gid=0
			{
				insertion: 'unshift',
				logic: ({
					eventData: {
						attributes: {
							class: classes = '',
							'data-location': dataLocation
						} = {},
						isSrpVehicleCta,
						widgetName
					} = {}
				}) => {
					let passLogic = false;
					if (
						widgetName === 'ws-vehicle-ctas' ||
						(isSrpVehicleCta &&
							!classes.includes('window-sticker-link')) || // SRP_VEHICLE_CTAS_WINDOW_STICKER_CLICK (NOT 2024 VERSION) SRP_VEHICLE_CTAS_BUTTON_CLICK
						['vehicle-ask-button', 'vehicle-drive-button'].includes(
							dataLocation
						) || // VDP_ASK_BUTTON_CLICK VDP_TEST_DRIVE_BUTTON_CLICK
						widgetName === 'links-window-sticker' || // VDP_VIEW_WINDOW_STICKER_CLICK
						(widgetName === 'ws-quick-specs' &&
							classes.includes('window-sticker-link')) // VDP_VEHICLE_CTAS_WINDOW_STICKER_2024_CLICK
					) {
						passLogic = true;
					}

					return passLogic;
				},
				payload: ({
					eventData: {
						attributes: {
							class: classes = '',
							'data-src': dataSrc
						} = {},
						backgroundColor,
						ctaIndex,
						isTelephonicUrl
					} = {}
				}) => {
					let payload = {
						...ascCtaInteraction
					};

					if (dataSrc) {
						payload.link_url = dataSrc;
					}

					if (classes.includes('dialog')) {
						payload.event_action_result = 'open';
					}

					payload.element_color = backgroundColor;
					payload.element_order = ctaIndex;

					if (isTelephonicUrl) {
						payload = [
							payload,
							{
								shared: [
									'[[mapping.configuration.sharedPayloads.sharedProps]]',
									'[[mapping.configuration.sharedPayloads.vehicleData]]',
									'[[mapping.configuration.sharedPayloads.clickToCall]]'
								]
							}
						];
					}

					return payload;
				}
			}
		]
	}
};
